import Dashboard from '../containers/dashboard'
import PaymentsToReviewManagement from '../containers/payments-to-review-management'

const PaymentsToReview = () => {
  return (
    <Dashboard>
      <PaymentsToReviewManagement />
    </Dashboard>
  )
}

export default PaymentsToReview
